import _ from 'lodash';
import {
    ROW_MAPPING_TARGET,
    ROW_MAPPING_TYPE,
    TEMPORARY_DESCRIPTOR_ID_PREFIX,
    TEMPORARY_ROW_ID_PREFIX,
} from '../../constants/generalConstants';
import { MappingsType, RowMappingType } from '../../types';

export function getReportClasses(isDragging: boolean, isOver: boolean): string {
    let classes = '';

    if (isDragging) {
        classes = `${classes} dragging`;
    }

    if (isOver) {
        classes = `${classes} over`;
    }

    return classes;
}

export function getEmptyMapping(): RowMappingType {
    const emptyMappingDescriptorId = _.uniqueId(TEMPORARY_DESCRIPTOR_ID_PREFIX);
    const emptyMappingConfidence = 100;
    const emptyMapping: RowMappingType = {
        type: ROW_MAPPING_TYPE.UNKNOWN,
        target: ROW_MAPPING_TYPE.UNKNOWN,
        rowId: _.uniqueId(TEMPORARY_ROW_ID_PREFIX),
        descriptorId: emptyMappingDescriptorId,
        confidence: emptyMappingConfidence,
        alternatives: [
            {
                confidence: emptyMappingConfidence,
                descriptorId: emptyMappingDescriptorId,
                target: ROW_MAPPING_TARGET.SELF,
                type: ROW_MAPPING_TYPE.INITIAL,
            },
        ],
    };

    return emptyMapping;
}

export function getHasEmptyMapping(mappings: MappingsType): boolean {
    return mappings.some(
        (mapping) =>
            mapping.rowId.startsWith(TEMPORARY_ROW_ID_PREFIX) &&
            mapping.descriptorId.startsWith(TEMPORARY_DESCRIPTOR_ID_PREFIX)
    );
}

export function ensureEmptyMapping(mappings: MappingsType): void {
    if (!getHasEmptyMapping(mappings)) {
        mappings.push(getEmptyMapping());
    }
}

export function getIsMappingEmpty(mapping: RowMappingType): boolean {
    return (
        mapping.rowId.startsWith(TEMPORARY_ROW_ID_PREFIX) &&
        mapping.descriptorId.startsWith(TEMPORARY_DESCRIPTOR_ID_PREFIX)
    );
}
